var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "40%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.info.type === 4 ? "icon名称" : "广告名称" } },
            [_vm._v(_vm._s(_vm.info.name))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.info.type === 4 ? "位置" : "广告位置" } },
            [_vm._v(_vm._s(_vm.info.locationKeyStr))]
          ),
          _vm.info.type === 5
            ? _c("el-descriptions-item", { attrs: { label: "展示页面" } }, [
                _vm._v(_vm._s(_vm.info.displayPageName)),
              ])
            : _vm._e(),
          _vm.info.type === 3
            ? _c("el-descriptions-item", { attrs: { label: "权重" } }, [
                _vm._v(_vm._s(_vm.info.sort)),
              ])
            : _vm._e(),
          _vm.info.type === 4
            ? _c("el-descriptions-item", { attrs: { label: "排序" } }, [
                _vm._v(_vm._s(_vm.info.sort)),
              ])
            : _vm._e(),
          _vm.info.type === 4 ||
          _vm.info.type === 3 ||
          _vm.info.type === 5 ||
          _vm.info.type === 2
            ? _c("el-descriptions-item", { attrs: { label: "展示地区" } }, [
                _vm._v(
                  _vm._s(_vm.info.areaNames ? _vm.info.areaNames.join(",") : "")
                ),
              ])
            : _vm._e(),
          _vm.info.type === 4
            ? _c("el-descriptions-item", { attrs: { label: "生效时间" } }, [
                _vm._v(
                  _vm._s(_vm.info.startTime) + " 至 " + _vm._s(_vm.info.endTime)
                ),
              ])
            : _c("el-descriptions-item", { attrs: { label: "活动时间" } }, [
                _vm._v(
                  _vm._s(_vm.info.startTime) + " 至 " + _vm._s(_vm.info.endTime)
                ),
              ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "图片" } },
            [
              _c("el-image", {
                staticStyle: { width: "120px", "margin-left": "30px" },
                attrs: {
                  src: _vm.info.imgUrl,
                  "preview-src-list": [_vm.info.imgUrl],
                },
              }),
            ],
            1
          ),
          _c("el-descriptions-item", { attrs: { label: "跳转页面" } }, [
            _vm._v(_vm._s(_vm.info.pageUrl)),
          ]),
          _vm.info.clientType === 1
            ? _c("el-descriptions-item", { attrs: { label: "跳转类型" } }, [
                _vm._v(
                  _vm._s(
                    _vm.info.pageUrlType === 1
                      ? "乘客端内部页面"
                      : _vm.info.pageUrlType === 2
                      ? "外部链接"
                      : "其他小程序（仅在微信小程序生效）"
                  )
                ),
              ])
            : _vm._e(),
          _vm.info.pageUrlType === 3
            ? _c("el-descriptions-item", { attrs: { label: "APPID" } }, [
                _vm._v(_vm._s(_vm.info.appId)),
              ])
            : _vm._e(),
          _vm.info.pageUrlType === 3
            ? _c("el-descriptions-item", { attrs: { label: "账号原始ID" } }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.info.appletOriginalId) + "\n    "
                ),
              ])
            : _vm._e(),
          _vm.info.clientType === 1
            ? _c("el-descriptions-item", { attrs: { label: "展示渠道" } }, [
                _vm._v(_vm._s(_vm.info.displayChannelName || "-")),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm.info.type !== 4
        ? _c("div", { staticClass: "title-box" }, [_vm._v("其他")])
        : _vm._e(),
      _vm.info.type !== 4
        ? _c(
            "div",
            { staticClass: "bottom-box" },
            [
              _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-left": "40px" },
                  attrs: { column: 1 },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
                    _vm._v(_vm._s(_vm.info.createUserName)),
                  ]),
                  _vm.info.status !== 1
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "审核人" } },
                        [_vm._v(_vm._s(_vm.info.updateUserName))]
                      )
                    : _vm._e(),
                  _c("el-descriptions-item", { attrs: { label: "广告状态" } }, [
                    _vm._v(_vm._s(_vm.info.statusTr)),
                  ]),
                  _vm.info.refuseReason
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "不通过原因" } },
                        [_vm._v(_vm._s(_vm.info.refuseReason))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { column: 1 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                    _vm._v(_vm._s(_vm.info.createTime)),
                  ]),
                  _vm.info.status !== 1
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "审核时间" } },
                        [_vm._v(_vm._s(_vm.info.auditTime))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.info.type === 4
        ? _c("div", { staticClass: "title-box" }, [_vm._v("操作日志")])
        : _vm._e(),
      _vm.info.type === 4
        ? _c(
            "el-timeline",
            { staticClass: "process" },
            _vm._l(_vm.info.logList, function (item) {
              return _c(
                "el-timeline-item",
                {
                  key: item.id,
                  attrs: {
                    "hide-timestamp": "",
                    timestamp: item.time,
                    placement: "top",
                  },
                },
                [
                  _c("div", { staticClass: "color-999" }, [
                    _c("span", { staticClass: "margin-right-10" }, [
                      _vm._v(_vm._s(item.createUserName)),
                    ]),
                    _c("span", [_vm._v(_vm._s(item.createTime))]),
                  ]),
                  _c("div", { staticClass: "margin-top-5" }, [
                    _c("span", [_vm._v("icon名称：")]),
                    _c("span", [_vm._v(_vm._s(item.name))]),
                  ]),
                  _c("div", { staticClass: "margin-top-5" }, [
                    _c("span", [_vm._v("生效时间：")]),
                    _c("span", [_vm._v(_vm._s(item.startTime))]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "margin-top-5 flex" },
                    [
                      _c("div", [_vm._v("图片：")]),
                      item.imgUrl
                        ? _c("el-image", {
                            staticStyle: { width: "50px", height: "40px" },
                            attrs: {
                              src: item.imgUrl,
                              "preview-src-list": [item.imgUrl],
                            },
                          })
                        : _c("div", [_vm._v("-")]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "margin-top-5" }, [
                    _c("span", [_vm._v("跳转页面：")]),
                    _c("span", [_vm._v(_vm._s(item.pageUrl || "-"))]),
                  ]),
                  _c("div", { staticClass: "margin-top-5" }, [
                    _c("span", [_vm._v("跳转类型：")]),
                    item.pageUrlType
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              item.pageUrlType === 1
                                ? "乘客端内部页面"
                                : item.pageUrlType === 2
                                ? "外部链接"
                                : "其他小程序（仅在微信小程序生效）"
                            )
                          ),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]),
                  _c("div", { staticClass: "margin-top-5 flex" }, [
                    _c("div", [_vm._v("排序：")]),
                    _c("span", [_vm._v(_vm._s(item.sort || "-"))]),
                  ]),
                  _c("div", { staticClass: "margin-top-5 flex" }, [
                    _c("div", [_vm._v("展示地区：")]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          item.allArea === 1
                            ? "全部"
                            : item.areaNames && item.areaNames.length > 0
                            ? item.areaNames.join(",")
                            : "-"
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }